module.exports = __webpack_public_path__ + "media/components/util/logos/vecteezy-logo--black-fc92a186a1a1426c7c5a80f52d1e7489.svg";